// API
import ApiBase from './ApiBase';
import { contractsUrl } from '../api/apiEndpoints';
import { IContract, IContractListItem } from '../interfaces/IContract';
import { GUIDType } from '../interfaces/types';
import { AnelmaContractStatusEnum } from '../interfaces/enums';

class ContractsApi extends ApiBase {
    createContract(payload: IContract) {
        return this.post<IContractListItem>(`${contractsUrl}/create-new`, payload);
    }

    getContractPdf(contractId: string) {
        return this.get<Blob>(`${contractsUrl}/file/${contractId}`, {
            responseType: 'blob',
            incompatibleResult: true,
        }).then((response) => {
                if (response) {
                    const blob = new Blob([response.Entity], { type: 'application/pdf' });
                    return blob;
                }
            });
    }

    getAllContracts() {
        return this.getList<IContractListItem>(`${contractsUrl}/contracts`);
    }

    getFarmContracts(companyId: string, companyName: string) {
        return this.getList<IContractListItem>(`${contractsUrl}/companyId/${companyId}/companyName/${companyName}`);
    }

    deleteContract(contractId: string) {
        // the DELETE returns HTTP 204 No Content
        // axios cannot atm get it
        // so here is a workaround
        return fetch(`${contractsUrl}/trash-and-delete/${contractId}`, {
            method: 'DELETE'
        });
        //this.delete<object>(`${contractsUrl}/trash-and-delete/${contractId}`);
    }

    startContractSignProcess(contractId: string) {
        let payload = { ContractId: contractId };
        return this.post<object>(`${contractsUrl}/start-signing-process`, payload);
    }

    getSingleContract(contractId: string) {
        return this.get<IContract>(`${contractsUrl}/contracts/${contractId}`);
    }

    terminateContract(contractId: string, terminationDate: Date, terminatedBySnellman: boolean) {
        let payload = {
            ContractId: contractId,
            TerminationDate: terminationDate,
            TerminatedBySnellman: terminatedBySnellman,
        }

        return this.patch<IContractListItem>(`${contractsUrl}/terminate`, payload);
    }

    changeContractStatus(contractId: string, status: AnelmaContractStatusEnum) {
        let payload = {
            ContractId: contractId,
            Status: status as number,
        }

        return this.patch<IContractListItem>(`${contractsUrl}/change-status`, payload);
    }
}

export default new ContractsApi();
